$(document).ready(function() {
    var is_ipl_user_logged_in = localStorage.getItem("is_ipl_user_logged_in");
    if (!is_ipl_user_logged_in) {
        $('.join-the-game-ipl-section').css('display', 'block');
    } else {
        $('.join-the-game-ipl-section').css('display', 'none');
    }
});

$(document).on('click' , '.join-the-game-ipl-section__content__button button' , function() {
    fetch_login();
});


function fetch_login() {
    $('#MainContent').addClass('login');
    var settings = {
        "url": "https://apis.thesleepcompany.in/ipl/user/avatars",
        "method": "GET",
        "timeout": 0,
    };

    $.ajax(settings).done(function(response) {
        var avtar_html = '';
        response.forEach(function(avatar, index) {
            if (index === 0) {
                var avatarIcon = avatar.img ? `<img src="${avatar.img}" data-avtar="${avatar.name}" class="player-avatar-image selected">` : '';
            } else {
                var avatarIcon = avatar.img ? `<img src="${avatar.img}" data-avtar="${avatar.name}" class="player-avatar-image">` : '';
            }
            avtar_html += avatarIcon;
        });
        $('.login-box-wrap.step-create-user .avtar-wrap').html(avtar_html);
        $('.join-the-game-ipl-section').css('display', 'none');
    });
}